import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import { SET_GAME_BONUS_RESULT_POST } from "../../api/ApiConst";
import { callPostApi } from "../../api/ApiCaller";
import ModalHalloween from "../common/ModalHalloween";
import CauldronAboboraBonus from "./CauldronAboboraBonus";
import { getFormattedAmountWithDenomination } from "../../utils/TextUtils";
import BombaCauldronAboboraBonus from "./BombaCauldronAboboraBonus";


let interactionDisabled = false;
function BombaCauldronBonus({ keyboardInput, gameSessionRecordId, onBonusRoundCompleted, walletBalance, denomination, gameResult }) {
    const boxesArr = [0, 1, 2, 3, 4];
    const StartBgRef = useRef(null);
    const [boxValues, setBoxValues] = useState(Array(boxesArr.length).fill(0));
    const [selectedBoxArray, setSelectedBoxArray] = useState([]);
    const [bonusValue, setBonusValue] = useState(0);
    const [premioValue, setPremioValue] = useState(0);
    const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
    const [isAnimatingPremioValue, setISAnimatingPremioValue] = useState(false);
    const [isAnimatingBonusValue, setIsAnimatingBonusValue] = useState(false);
    const startNumRef = useRef(null);
    const endNumRef = useRef(null);
    const keys = {
        "y": 0,
        "j": 1,
        "h": 2,
        "m": 3,
        "n": 4
    }

    const playSoundById = (soundTagId) => {
        let sound = $("#" + soundTagId)[0];
        if (sound) {
            sound.currentTime = 0;
            sound.play();
        }
    };
    const pauseSoundById = (soundTagId) => {
        let sound = $("#" + soundTagId)[0];
        if (sound) {
            sound.pause();
            sound.currentTime = 0;
        }
    };

    useEffect(() => {
        StartBgRef.current = $("#caldeiraoFireOnStart")[0];

        if (StartBgRef.current) {
            StartBgRef.current.loop = true;
            if (StartBgRef.current.paused) {
                StartBgRef.current.play().catch((err) => {
                    console.error("Audio play failed:", err);
                });
            }
        }
    }, [])


    useEffect(() => {
        const handleKeyPress = (event) => {
            const key = event.key.toLowerCase();

            if (Object.keys(keys).includes(key)) {
                handleBoxClick(boxesArr[keys[key]], keys[key])
            }
        };

        if (keyboardInput) {
            window.addEventListener("keydown", handleKeyPress);
            return () => {
                window.removeEventListener("keydown", handleKeyPress);
            };
        }


    }, [keyboardInput, gameSessionRecordId]);


    const handleCauldronSound = () => {
        let winningDiv = document.getElementById("cauldron03-gameWin");
        let wheelToggleClass = document.getElementById("cauldron03-bonusWinnings");
        let startSound = startNumRef.current;
        let endSound = endNumRef.current;

        setTimeout(() => {
            if (startSound) {
                let startSoundCount = 0;

                // setShowValue(true);
                const startSoundInterval = setInterval(() => {
                    if (startSoundCount < 2) {
                        wheelToggleClass.classList.add('d-none');
                        setTimeout(() => {
                            if (wheelToggleClass.classList.contains('d-none')) {
                                wheelToggleClass.classList.remove('d-none');
                            }
                        }, 200);
                        // setShowValue(prev => !prev);
                        if (startSound) {
                            startSound.play();
                        }
                        startSoundCount++;
                    } else {
                        clearInterval(startSoundInterval);
                        if (startSound) {
                            startSound.pause();
                        }
                        startSound.currentTime = 0;
                    }
                }, 900);
            }
        }, 2000);

        if (endSound) {
            setTimeout(() => {
                let endSoundCount = 0;

                const endSoundInterval = setInterval(() => {
                    if (endSoundCount < 3) {
                        winningDiv.classList.add('d-none');
                        setTimeout(() => {
                            if (winningDiv.classList.contains('d-none')) {
                                winningDiv.classList.remove('d-none');
                            }
                        }, 200);
                        if (endSound) {
                            endSound.play();
                        }
                        endSoundCount++;
                    } else {
                        clearInterval(endSoundInterval);
                        if (endSound) {
                            endSound.pause();
                        }
                        endSound.currentTime = 0;
                    }
                }, 900);
            }, 3700);
        }
    }

    const animatePremioValue = (totalGameWinning) => {
        if (isAnimatingPremioValue) return;
        setISAnimatingPremioValue(true);

        let currentValue = totalGameWinning;
        const steps = 50;
        const stepSize = totalGameWinning / steps;
        const animationSpeed = 10;

        const intervalId = setInterval(() => {
            currentValue -= stepSize;
            setPremioValue(Math.round(currentValue));

            if (currentValue <= 0 || Math.abs(currentValue) < Math.abs(stepSize)) {
                clearInterval(intervalId);
                setPremioValue(0);
                // setISAnimatingPremioValue(false);
            }
        }, animationSpeed);
    };

    const animateBonusValue = (totalGameWinning) => {
        if (isAnimatingBonusValue) return;
        setIsAnimatingBonusValue(true);

        let currentValue = 0;
        const steps = 50;
        const stepSize = totalGameWinning / steps;
        const animationSpeed = 10;

        const intervalId = setInterval(() => {
            currentValue += stepSize;
            setBonusValue(Math.round(currentValue));

            if (currentValue >= totalGameWinning || Math.abs(totalGameWinning - currentValue) < Math.abs(stepSize)) {
                clearInterval(intervalId);
                setBonusValue(totalGameWinning);
                setIsAnimatingBonusValue(false);

                setTimeout(() => {
                    onBonusRoundCompleted(totalGameWinning);
                    interactionDisabled = false;
                    setISAnimatingPremioValue(false);
                }, 6000);
            }
        }, animationSpeed);
    };

    const handleBoxClick = (value, index) => {
        if (interactionDisabled) return;
        if (value.disabled) return;

        let stopSound = StartBgRef.current
        if (!stopSound.paused) {
            stopSound.pause();
        }

        interactionDisabled = true;

        // Update clicked box values
        const updatedBoxValues = [...boxValues];
        updatedBoxValues[index] = null;
        setBoxValues(updatedBoxValues);

        // Add win animation class to clicked box
        const cauldronClickIndex = document.getElementById(`cauldronGame-03Click-${index}`);
        if (cauldronClickIndex && !cauldronClickIndex.classList.contains("winIndex-anim")) {
            cauldronClickIndex.classList.add("winIndex-anim");
        }

        if (!selectedBoxArray.includes(value)) {
            setSelectedBoxArray((prev) => [...prev, value]);
        }

        playSoundById('caldeiraoWinStart03')
        setTimeout(() => {
            pauseSoundById('caldeiraoWinStart03')
        }, 1200);

        let payload = {
            bonusType: "Bonus03ACauldron",
            recordId: gameSessionRecordId,
            tileNumber: index,
        };

        callPostApi(SET_GAME_BONUS_RESULT_POST, payload, {}, (response) => {
            let res = response?.responsePacket;
            if (response?.errorCode === 0) {
                let bonusNumber = res?.bonusDetails?.bonus;
                // let bonusNumber = 0;
                let totalGameWinning = res?.totalWinnings
                let newOtherBoxWin = res?.otherPossibleWinningsNumber
                setTimeout(() => {
                    playSoundById('caldeiraoAniEnd03')
                }, 1300);
                setTimeout(() => {
                    pauseSoundById('caldeiraoAniEnd03')
                }, 2000);

                const availableValues = [...newOtherBoxWin];
                const randomStaticValues = boxesArr.map((_, i) => {
                    if (i === index) return bonusNumber;
                    const randomIndex = Math.floor(Math.random() * availableValues.length);
                    return availableValues.splice(randomIndex, 1)[0];
                });
                setBoxValues(randomStaticValues);

                if (bonusNumber > 0) {
                    handleCauldronSound()
                    setTimeout(() => {
                        setPremioValue(() => {
                            animatePremioValue(totalGameWinning);
                            return totalGameWinning;
                        });
                        animateBonusValue(totalGameWinning);
                    }, 1000);
                }
                else if (bonusNumber === 0) {
                    setTimeout(() => {
                        setIsSecondModalOpen(true)
                        interactionDisabled = false;
                    }, 3000);
                }

                setTimeout(() => {
                    boxesArr.forEach((i) => {
                        const bonusNum = document.getElementById(`cauldron02-bonusNum-${i}`);
                        const BonusImg = document.getElementById(`cauldron02-BonusImg-${i}`);

                        if (bonusNum) {
                            bonusNum.classList.remove("d-none");
                            bonusNum.classList.add("d-flex");
                        }

                        if (BonusImg) {
                            BonusImg.classList.remove("d-none");
                            BonusImg.classList.add("d-flex");
                        }
                    });
                }, 200);
            } else {
                console.error("API Call Failed:", response?.errorMessage || "Unknown error");
                interactionDisabled = false;
            }
        })
    };

    const loadStaticAudio = () => {
        return (
            <>
                <div style={{ display: "none" }}>
                    {/* Load Audio as Well */}
                    <audio controls="" id="caldeiraoAniEnd03" className="audioFile">
                        <source src="assets/bonus4_premioiwin.ogg" type="audio/mpeg" />
                    </audio>
                    <audio controls="" id="caldeiraoWinStart03" className="audioFile">
                        <source src="assets/cald_pr-click.ogg" type="audio/mpeg" />
                    </audio>
                    <audio controls="" id="jumpingPumpkin04" className="audioFile">
                        <source src="assets/jumpingPumpkin.wav" type="audio/mpeg" />
                    </audio>
                    <audio controls="" ref={endNumRef} id="plopNumSound" className="audioFile">
                        <source src="assets/plop.wav" type="audio/mpeg" />
                    </audio>
                    <audio controls="" ref={startNumRef} id="stakeNumStart" className="audioFile">
                        <source src="assets/stake.mp3" type="audio/mpeg" />
                    </audio>
                    <audio controls="" id="caldeiraoFireOnStart" className="audioFile">
                        <source src="assets/cald_fundo-background.ogg" type="audio/mpeg" />
                    </audio>
                </div>
            </>
        );
    };


    return (
        <>
            <div className="h-100 w-100 position-relative bomba-cauldron">
                <img className="h-100 w-100" src="assets/img/cauldron/bg.jpg" alt="" />
                <div className="contentPosition p-0">
                    <div className="cauldron-content">
                        <div className="cauldron-inner-content">
                            <div className="text-center header-h">
                                <img className="w-100 h-100" src="assets/img/cauldron/header-logo.png" alt="" />
                            </div>
                            <div className="cauldron-game-content" style={{ width: "85%" }}>
                                {boxesArr.map((box, index) => (
                                    <div
                                        id={`cauldronGame-03Click-${index}`}
                                        key={index}
                                        className={`cauldron-game-content-col position-relative w-100 h-100 `}
                                        onClick={() => {
                                            if (!interactionDisabled) {
                                                handleBoxClick(box, index);
                                            }
                                        }}
                                    >
                                        {boxValues !== null && interactionDisabled ? (
                                            <div className="cauldron-img-2">
                                                <img className="caldeirao-gif" src={`assets/img/cauldron/caldeirao-bolha.gif?v=${gameSessionRecordId + "-" + index}`} alt="" />
                                                <img className="caldeirao-png" src={`assets/img/cauldron/caldeirao.gif?v=${gameSessionRecordId + "-" + index}`} alt="" />
                                                <div className="text-content">
                                                    {boxValues[index] === 0 ? (
                                                        <div className="text-content">
                                                            <img
                                                                id={`cauldron02-BonusImg-${index}`}
                                                                className="premioBonusAbobora d-none"
                                                                src="assets/img/cauldron/premioBonusAbobora.png"
                                                                alt=""
                                                            />
                                                        </div>
                                                    ) : (
                                                        boxValues[index] !== null && (
                                                            <div id={`cauldron02-bonusNum-${index}`} className="text-content d-none">
                                                                {boxValues[index]}
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <img src={`assets/img/cauldron/caldeirao.gif?v=${gameSessionRecordId + "-" + index}`} alt="" />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="cauldron-footer-content pt-2">
                        <div className="cauldron-footer-top-content " style={{ gap: "5%" }}>
                            <div className="cauldron-footer-btn-box">
                                <div className=" d-flex w-100" style={{ height: "33.33%" }}>
                                    <div className="col-6 text-center d-flex align-items-center justify-content-center">
                                        <img className="w-75 h-75" src="assets/img/cauldron/text2.png" alt="" />
                                    </div>
                                    <div className="col-6 position-relative">
                                        <span className="cauldron-btn position-absolute start-0 top-0 end-0 bottom-0 z-1" id="cauldron03-bonusWinnings">{isAnimatingPremioValue ? premioValue : gameResult.winnings}</span>
                                        <img className="w-100 h-100" src="assets/img/cauldron/btn-bg.png" alt="" />
                                    </div>
                                </div>
                                <div className=" d-flex w-100" style={{ height: "33.33%" }}>
                                    <div className="col-6 text-center d-flex align-items-center justify-content-center">
                                        <img className="w-75 h-75" src="assets/img/cauldron/text3.png" alt="" />
                                    </div>
                                    <div className="col-6 position-relative">
                                        <span className="cauldron-btn position-absolute start-0 top-0 end-0 bottom-0 z-1"> {getFormattedAmountWithDenomination(walletBalance, denomination)}</span>
                                        <img className="w-100 h-100" src="assets/img/cauldron/btn-bg.png" alt="" />
                                    </div>
                                </div>
                                <div className=" d-flex w-100" style={{ height: "33.33%" }}>
                                    <div className="col-6 text-center d-flex align-items-center justify-content-center">
                                        <img className="w-75 h-75" src="assets/img/cauldron/text1.png" alt="" />
                                    </div>
                                    <div className="col-6 position-relative">
                                        <span className="cauldron-btn position-absolute start-0 top-0 end-0 bottom-0 z-1" id="cauldron03-gameWin">{bonusValue}</span>
                                        <img className="w-100 h-100" src="assets/img/cauldron/btn-bg.png" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="w-100">
                                <div className="text-center" style={{ height: "25%" }}>
                                    <img className="img-fluid blink_me h-100 w-100" src="assets/img/cauldron/caldeirao-frase.png" alt="" />
                                </div>
                                <div className="text-center" style={{ height: "33.33%" }}>
                                    <img className="img-fluid w-100 h-100" src="assets/img/cauldron/caldeirao-multiplique.png" alt="" />
                                </div>
                                <div className="cauldron-btn" style={{ height: "33.33%" }}>
                                    <img className="img-fluid w-100 h-100" src="assets/img/cauldron/caldeirao-bonus.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div style={{ height: "15%" }}></div>
                        <div className="cauldron-footer-bottom-content text-center ">
                            <img className=" img-fluid w-100 h-100 " src="assets/img/cauldron/footer-logo.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            {isSecondModalOpen && (
                <ModalHalloween show={isSecondModalOpen} toggleModel={() => { }}>
                    <div className="modal-dialog modal-fullscreen">
                        <div className="modal-content" style={{ background: "#0a0f29" }}>
                            <div className="modal-body text-center p-0 bg-help">
                                <div className="h-100">
                                    {
                                        <BombaCauldronAboboraBonus keyboardInput={keyboardInput} gameSessionRecordId={gameSessionRecordId}
                                            onBonusRoundCompleted={onBonusRoundCompleted} walletBalance={walletBalance} denomination={denomination} gameResult={gameResult} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalHalloween>
            )}
            {loadStaticAudio()}
        </>


    );
}

export default BombaCauldronBonus;
